import "./Input.css";
import React, { useRef, useImperativeHandle, ReactNode } from "react";

type Props = {
  className?: string;
  errorMsg?: string | ReactNode;
  required?: boolean;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  title?: string;
  placeholder?: string;
  type?: string;
  readOnly?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  extraPadding?: boolean;
  disable?: boolean;
  formDescription?: string;
};

type CustomTextInputHandle = {
  focusInput: () => void;
  blurInput: () => void;
};

const CustomTextInput: React.ForwardRefRenderFunction<
  CustomTextInputHandle,
  Props
> = (
  {
    className = "",
    errorMsg = "",
    required = false,
    value = "",
    onChange,
    title = "",
    placeholder = "",
    type = "text",
    readOnly = false,
    onKeyDown,
    extraPadding = true,
    disable = false,
    formDescription,
  },
  ref
) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => {
    return {
      focusInput: () => {
        inputRef.current?.focus();
      },
      blurInput: () => {
        inputRef.current?.blur();
      },
    };
  });

  return (
    <div className={`${className} ${extraPadding ? "pe-2" : ""}`}>
      {title && (
        <p className="input-title">
          {title} {required && <span className="text-danger">*</span>}
        </p>
      )}
      <input
        onKeyDown={onKeyDown}
        ref={inputRef}
        readOnly={readOnly}
        type={type}
        required={required}
        value={
          value === null ||
          // value === "0" ||
          (type === "number" && parseInt(value) < 0)
            ? ""
            : value
        }
        onChange={onChange}
        className={`input-field ${errorMsg ? "error" : ""} ${
          readOnly ? "bg-light" : ""
        }`}
        placeholder={placeholder}
        onWheel={(e) => e.currentTarget.blur()}
        disabled={disable}
        // onWheel does not let scroll

        style={{
          cursor: disable ? "not-allowed" : "auto",
          opacity: disable ? 0.5 : 1,
        }}
      />
      {formDescription && (
        <p
          className="input-title"
          style={{
            fontSize: 11,
            fontWeight: 400,
            color: "#6c757d",
          }}
        >
          {formDescription}
        </p>
      )}
      {errorMsg ? (
        <p className="input-error">* {errorMsg} </p>
      ) : (
        <p className="input-error">&nbsp;</p>
      )}
    </div>
  );
};

// merge conflict resolved -12

export default React.forwardRef(CustomTextInput);
